module.exports = require('../dist/components/Modal/Modal');
